import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilty, AppMetadataHandler } from 'app';
import { MultiLingualService } from 'app/BaseFramework';

import ruleData from './rule-data.json';

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss']
})
export class DataListComponent implements OnInit {

  constructor(private commonUtility: CommonUtilty,
    private multiLingualService : MultiLingualService) { }

  @Input() listFor: string = "";
  @Input() title: string = "";
  @Input() listOfData: Array<any> = [];
  @Input() filterBasedOn: string = 'decision';

  lookupsToBind = ['translationLanguageCd'];
  lookup$: any = this.commonUtility.initializeLookupList(this.lookupsToBind);

  ngOnInit(): void {
    this.setConfiguration();
    this.listOfData = this.applyColor(this.listOfData, this.filterBasedOn);
    this.createFilterLookup();
    this.calculateCount();
    this.filterList(this.filterListBy);
    this.lookup$ = this.commonUtility.initializeLookupList(this.lookupsToBind);
    this.fetchLookupData();
  }

  filteredDataList = [];
  filterLookup = [];
  filterListBy: any = "ALL";

  setConfiguration(){
    if(this.listFor == 'MEDICAL_RULES'){
      this.dataListConfig = this.medicalRulesConfiguration;
    }else{
      this.dataListConfig = this.ruleConfiguration;
    }
  }

  createFilterLookup() {
    if (this.commonUtility.isArrayIterable(this.listOfData)) {
      let tempArray = [];
      this.listOfData.forEach(element => {
        if (element[this.filterBasedOn] && tempArray.indexOf(element[this.filterBasedOn]) === -1) {
          tempArray.push(element[this.filterBasedOn]);
        }
      });
      tempArray.forEach(element => {
        this.filterLookup.push({ lookupKey: element, lookupValue: this.getMappedStatus(element) });
      });
      this.filterLookup.unshift({ lookupKey: 'ALL', lookupValue: 'All' });
    }
  }

  getMappedStatus(lookupValue){
    if (lookupValue === 'STANDARD') {
      return 'Auto-Approve';
      

    } else if (lookupValue === 'Reject' || lookupValue === 'Rejected' || lookupValue === 'REJECT' || lookupValue === 'REJECTED') {
      return 'Auto-Reject';
    } else if (lookupValue === 'REFER') {
      return 'Manual Review';
    } else {
      return lookupValue; 
    }
  }
  

  filterList(type) {
    if(type && this.listOfData){
      //if (type === 'ALL') this.filteredDataList = this.listOfData.filter(x => x[this.filterBasedOn]);
      if (type === 'ALL') this.filteredDataList = [...this.listOfData];
      // for life demo
      //if (type === 'ALL') this.filteredDataList = [...this.medicalRulesDataConfiguration];
      else {
        let filterBasedOn = this.filterBasedOn;
        this.filteredDataList =this.listOfData.filter(function(x) {
          if(x[filterBasedOn]){
            return x[filterBasedOn].toLowerCase() == type.toLowerCase()
          }
        });
      }
    }
  }

  filteredItemsCount = [];
  calculateCount() {
    if (this.commonUtility.isArrayIterable(this.filterLookup)) {
      this.filterLookup.forEach(element => {
        if (element.lookupKey != 'ALL') {
          let count = this.listOfData.filter(item => element.lookupKey == item[this.filterBasedOn]).length;
          this.filteredItemsCount.push({ key: element.lookupKey, name: element.lookupValue, count: count });
        }
      });
      this.applyColor(this.filteredItemsCount, 'name');
    }

  }

  positiveValue = ['ACCEPTED', 'ACCEPTED STANDARD', 'PASSED', 'STANDARD', 'Accepted', 'Passed', 'PASS', 'Pass'];
  negativeValue = ['REJECTED', 'FAILED', 'Rejected', 'Failed', 'FAIL', 'Fail'];
  NeutralValue = ['REFER', 'REFERRED AND RATED', 'Refer'];

  applyColor(dataList, key) {
    if (this.commonUtility.isArrayIterable(dataList)) {
      dataList.forEach(item => {
        if (this.positiveValue.includes(item[key])) {
          item['icon'] = 'check-circle';
          item['color'] = 'success';
        }
        else if (this.negativeValue.includes(item[key])) {
          item['icon'] = 'close-circle';
          item['color'] = 'danger';
        }
        else if (this.NeutralValue.includes(item[key])) {
          item['icon'] = 'exclamation-circle';
          item['color'] = 'warning';
        } else {
          item['icon'] = 'check-circle';
          item['color'] = 'default';
        }
      });
    }
    return dataList;
  }

  sortName: string | null = null;
  sortValue: string | null = null;
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;

    if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.filteredDataList = this.commonUtility.deepCopy(this.commonUtility.sortObject(this.sortName, this.filteredDataList, orderBy))
    } else {
      this.filteredDataList = this.listOfData;
    }
    console.log("sorted filteredDataList", JSON.stringify(this.filteredDataList));
  }

  searchValue: null;
  filterKey = null;

  filterMenuVisibilityChanged(event) {
    this.searchValue = null;
  }

  getConfigKey(key) {
    this.filterKey = key;
    console.log("config key", key);
  }

  searchConfiguration(value) {
    if (value) {
      this.filteredDataList = this.listOfData.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
      this.searchValue = null;
    }
  }

  reset(): void {
    this.searchValue = null;
    this.filteredDataList = this.listOfData;
  }


  translationLanguageLookup = [];
  fetchLookupData() {
    this.lookup$['translationLanguageCd'].subscribe(lookup => {
      this.translationLanguageLookup = lookup;
      // this.currencyLookup = cur
    });
    // this.lookup$['productOptionCd'].subscribe(lookup => {
    //   this.packageTypeLookup = lookup;
    //   console.log("packageTypeLookup", JSON.stringify(this.packageTypeLookup));
    // });
  }
  openTranslateModal:boolean = false;
  selectedLanguage: string;
  translatedRules = [];
  loadSpinner: boolean = false;

  translateRules(lang){
    console.log("selected language: ", lang)
    console.log("filtered rules list: ", this.filteredDataList)
    let concatAllRuleNames = [];

    if(this.filteredDataList && this.filteredDataList.length){
      this.filteredDataList.forEach((rule,i) => {
        // let index = "Text"+(i+1)
        let obj = {
          index: ""
        }
        for (const key in obj){
          if (obj.hasOwnProperty(key))
          concatAllRuleNames.push(obj[key + i+1] = "The Rule " + rule.ruleName + " has been " + rule.decision)
           delete obj[key]
        }
        // concatAllRuleNames.push(obj);
        // concatAllRuleNames.push("The Rule " + rule.ruleName + "has been " + rule.decision);
      })
    }
    let requestBody = {
      "product_type" : "LIFE_Claims_Dev",
      "module_name" : "MetaGPT",
      "business_process": "FWARISKANALYSIS",
      "rules" : concatAllRuleNames,
      "lang" : lang || 'English'
    }
    this.loadSpinner = true;
    console.log("request body: ", requestBody)
    this.multiLingualService.generateInsightsFromRuleOutput(requestBody).subscribe(resp => {
      console.log("translate resp: ", resp)
      this.loadSpinner = false;
      this.translatedRules = resp;
      if(this.translatedRules && this.translatedRules.length){
        this.translatedRules.forEach((rule,i) => {
          rule['id'] = i+1;
        })
      }
    }, (e)=>{
      this.loadSpinner = false;
      console.log("error captured  for rules translation: ", e)
    })

  }

  dataListConfig = {
    "title":'',
    "listHeader": []
  };

  medicalRulesConfiguration = {
    "title": "Medical rules list",
    "listHeader": [
      {
        "header": "Test Name",
        "key": "testCd",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "400px"
      },
      {
        "header": "Result",
        "key": "result",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "200px",
        "applyColor": true,
        "pipe": true
      },
      {
        "header": "Risk Rating",
        "key": "riskRating",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "200px",    
        "pipe": true
      },
      {
        "header": "Risk Score",
        "key": "riskScore",
        "searchFilter": false,
        "sortFilter": true,
        "width": "200px",
        "isVisible": true
      },
      {
        "header": "Reason",
        "key": "reason",
        "searchFilter": false,
        "sortFilter": false,
        "isVisible": true,
        "width": "250px"
      },
      {
        "header": "Recommendation",
        "key": "recommendation",
        "searchFilter": false,
        "sortFilter": false,
        "isVisible": true,
        "width": "300px"
      }
    ]
  };

  medicalRulesDataConfiguration = [
    {
      testCd: "Haemoglobin",
      result: "Additional Requirement",
      riskRating: "High",
      riskScore: "5",
      reason: "Haemoglobin below normal range",
      recommendation: "Additional reports required due to very low haemoglobin, High Risk of anaemia"
    },
    {
      testCd: "Lipid Profile",
      result: "Standard",
      riskRating: "Low",
      riskScore: "5",
      reason: "Normal",
      recommendation: "-"
    },
    {
      testCd: "Serum Albumin",
      result: "Standard",
      riskRating: "Low",
      riskScore: "2",
      reason: "The serum albumin level is at the borderline level",
      recommendation: "The serum albumin level is at the lower limit of the normal range"
    },
    {
      testCd: "White blood cells (WBC)	",
      result: "Standard",
      riskRating: "Low",
      riskScore: "0",
      reason: "WBC count is normal",
      recommendation: "-"
    },
    {
      testCd: "BMI",
      result: "Standard",
      riskRating: "Medium",
      riskScore: "3",
      reason: "BMI is above normal range, overweight",
      recommendation: "-"
    },
  ]
  
  ruleConfiguration = {
    "title": "Rules list",
    "listHeader": [
      {
        "header": "Rule Name",
        "key": "ruleName",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "20%"
      },
      {
        "header": "Result",
        "key": "decisionValue",
        "searchFilter": true,
        "sortFilter": true,
        "isVisible": true,
        "width": "15%"
      },
      // {
      //   "header": "Category",
      //   "key": "category",
      //   "searchFilter": true,
      //   "sortFilter": false,
      //   "isVisible": true,
      //   "width": "150px",
      //   "pipe": true
      // },
      {
        "header": "Decision",
        "key": "decision",
        "searchFilter": false,
        "sortFilter": true,
        "isVisible": true,
        "width": "15%",
        "applyColor": true,
        "pipe": true
      },
      {
        "header": "Recommendation",
        "key": "recommendation",
        "searchFilter": false,
        "sortFilter": false,
        "isVisible": true,
        "width": "20%"
      }
    ]
  }

}
